/* Header menu pictures (Eternal Elegance). The picture cards in the menu carry data-ee-src instead of src, so they
   cost nothing on page load. They load the first time a shopper reaches for the menu: hovering or tabbing into the
   desktop menu, or pressing the phone menu button. On desktop they also load quietly a few seconds after the page has
   finished loading, so the first dropdown opens with its pictures ready. */
(function () {
  var done = {};
  function hydrate(root) {
    if (!root) return;
    root.querySelectorAll('img[data-ee-src]').forEach(function (img) {
      if (img.dataset.eeSrcset) img.srcset = img.dataset.eeSrcset;
      img.src = img.dataset.eeSrc;
      img.removeAttribute('data-ee-src');
      img.removeAttribute('data-ee-srcset');
    });
  }
  function once(key, root) {
    if (done[key]) return;
    done[key] = true;
    hydrate(root);
  }
  function init() {
    var desk = document.querySelector('#header .full-menu');
    var phone = document.getElementById('mobile-menu');
    var toggle = document.querySelector('#header .mobile-toggle');
    if (desk) {
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
        desk.addEventListener(ev, function () { once('desk', desk); }, { passive: true });
      });
      if (window.matchMedia && window.matchMedia('(min-width: 1068px)').matches) {
        var later = function () { setTimeout(function () { once('desk', desk); }, 3000); };
        if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
      }
    }
    if (toggle && phone) {
      ['pointerdown', 'touchstart', 'click'].forEach(function (ev) {
        toggle.addEventListener(ev, function () { once('phone', phone); }, { passive: true });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();